/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserFacilityAccess } from './UserFacilityAccess';
import {
    UserFacilityAccessFromJSON,
    UserFacilityAccessFromJSONTyped,
    UserFacilityAccessToJSON,
} from './UserFacilityAccess';

/**
 * 
 * @export
 * @interface FindAllUserFacilityAccess200Response
 */
export interface FindAllUserFacilityAccess200Response {
    /**
     * 
     * @type {Array<UserFacilityAccess>}
     * @memberof FindAllUserFacilityAccess200Response
     */
    data?: Array<UserFacilityAccess>;
}

/**
 * Check if a given object implements the FindAllUserFacilityAccess200Response interface.
 */
export function instanceOfFindAllUserFacilityAccess200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllUserFacilityAccess200ResponseFromJSON(json: any): FindAllUserFacilityAccess200Response {
    return FindAllUserFacilityAccess200ResponseFromJSONTyped(json, false);
}

export function FindAllUserFacilityAccess200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllUserFacilityAccess200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(UserFacilityAccessFromJSON)),
    };
}

export function FindAllUserFacilityAccess200ResponseToJSON(value?: FindAllUserFacilityAccess200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(UserFacilityAccessToJSON)),
    };
}

